module.exports = __webpack_public_path__ + "static/media/animated_logo.dcd6dee2.svg";